(function ($) {
    $(function () {
        // Hide "expand all" button on LearnDash course lists when there is only
        // one course to expand.
        $('.ld-item-list').each(function (containerIndex, containerNode) {
            var container = $(containerNode);
            var items = container.find('.ld-item-list-item.ld-expandable');
            var button = container.find('.ld-item-list-actions .ld-expand-button');

            if (items.length > 1 || button.length === 0) {
                return;
            }

            button.hide();
        });
    });
})(jQuery);
